var render, staticRenderFns
import script from "./NewsletterRegistration.vue?vue&type=script&lang=js"
export * from "./NewsletterRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fde7986')) {
      api.createRecord('5fde7986', component.options)
    } else {
      api.reload('5fde7986', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/NewsletterRegistration.vue"
export default component.exports